// extracted by mini-css-extract-plugin
export var accessibilityLinks = "layout-module--accessibilityLinks--2adbd";
export var accessibilityLinksHide = "layout-module--accessibilityLinksHide--7c814";
export var container = "layout-module--container--3bf91";
export var desktop = "layout-module--desktop--4caac";
export var footer = "layout-module--footer--ecf8c";
export var headerContainer = "layout-module--headerContainer--fc303";
export var layoutContainer = "layout-module--layoutContainer--08b80";
export var rootNav = "layout-module--rootNav--275bf";
export var scrollToTopClass = "layout-module--scrollToTopClass--34cdb";
export var smartphone = "layout-module--smartphone--639a3";